/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowDownRight12: {
  name: 'arrow-down-right-12';
  data: string;
} = {
  name: 'arrow-down-right-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M8 6V4.502a.5.5 0 0 1 .818-.386l2.997 2.47a.5.5 0 0 1 .004.768l-2.996 2.53A.5.5 0 0 1 8 9.502V8H1a1 1 0 0 1-1-1V2a1 1 0 1 1 2 0v4z" fill-rule="evenodd"/></svg>`
};
